// guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, switchMap, take, filter } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.initialized$.pipe(
      filter(init => init),          // espera bootstrapAuth() terminar
      take(1),
      switchMap(() => this.auth.isAuthenticated$),
      take(1),
      map(ok => ok ? true : this.router.createUrlTree(['/login']))
    );
  }
}
